define('lq/csrfToken',[
    'jquery',
    'lq',
    'lq/ajax'
], function ($, lq, ajax) {
    'use strict';

    // no underscores in the header: some proxies and firewalls drop such headers (see ValidateJsonAntiForgeryTokenAttribute)
    var headerName = 'X-Request-Verification-Token';
    var fieldName = '__RequestVerificationToken';
    var expectedUserFieldName = '__ExpectedUser';
    var expectedUserHeaderName = 'X-Expected-User';
    var userChangedReason = 'user_changed';

    var getFieldFromPage = function (name) {
        return $('input[name="' + name + '"]', $('#__AjaxAntiForgeryForm')).val();
    };

    var getFieldFromResponse = function (html, name) {
        return $('<div/>').html(html).find('input[name="' + name + '"]').val();
    };

    // The token belongs to the logged in user, not to a dispatcher. A dispatcher is created for every action,
    // so they all share the token the last refresh produced (the form in the page only holds the first one).
    // user is the user the page was rendered for. It only changes when this page changes the user itself (login,
    // logoff), never when a token is recovered: see recover.
    var state = { token: undefined, user: undefined, refresh: null };

    var userChangedListener = null;

    var csrfToken = {};

    Object.defineProperty(csrfToken, 'token', {
        get: function () { return state.token; },
        set: function (token) { state.token = token; }
    });

    Object.defineProperty(csrfToken, 'user', {
        get: function () { return state.user; },
        set: function (user) { state.user = user; }
    });

    // Takes over the token and the user the page was rendered with, unless there already is a token.
    csrfToken.initializeFromPage = function () {
        if (state.token === undefined) {
            state.token = getFieldFromPage(fieldName);
            state.user = getFieldFromPage(expectedUserFieldName);
        }
    };

    // Asks the server for a token. When a user is given the server only answers if that is still the logged in user.
    var requestToken = function (expectedUser, success, failure) {
        var headers = {};
        if (expectedUser)
            headers[expectedUserHeaderName] = expectedUser;

        $.ajax({ url: lq.getTenantUrl('LicquidAction/GetCsrfToken'), cache: false, headers: headers })
            .done(function (data) {
                success(getFieldFromResponse(data, fieldName), getFieldFromResponse(data, expectedUserFieldName));
            })
            .fail(function (jqXHR) {
                failure(jqXHR);
            });
    };

    // Headers for requests that do not go through a dispatcher (e.g. file uploads).
    csrfToken.headers = function () {
        var headers = {};
        if (state.token)
            headers[headerName] = state.token;
        return headers;
    };

    // For the pages that change the user on purpose (login, logoff): the token and the user are replaced.
    csrfToken.refresh = function (callback, error) {
        requestToken(undefined, function (token, user) {
            state.token = token;
            state.user = user;
            callback();
        }, function () {
            (error || $.noop)();
        });
    };

    // Called when the server rejected a request because of its anti-forgery token (e.g. the identity of the
    // user changed in another tab). staleToken is the token that was sent with the rejected request.
    // The page only gets a new token when it is still the user the page was rendered for, so a request that the
    // previous user started is never replayed as another user.
    csrfToken.recover = function (staleToken, success, failure) {
        // another rejected request already replaced the token
        if (state.token && state.token !== staleToken) {
            success();
            return;
        }

        // concurrent rejected requests share a single refresh
        var refresh = state.refresh;
        if (!refresh) {
            refresh = state.refresh = $.Deferred();
            requestToken(state.user, function (token) {
                state.token = token;
                state.refresh = null;
                refresh.resolve();
            }, function (jqXHR) {
                state.refresh = null;
                if (ajax.failureReason(jqXHR) === userChangedReason)
                    csrfToken.handleUserChanged();
                refresh.reject();
            });
        }
        refresh.done(success).fail(failure);
    };

    // Adds the anti-forgery token to the options of a request that is sent with ajax.withRetry and makes sure that
    // the request is replayed once with a fresh token when the server rejects it (see ajax.js).
    csrfToken.protectRequest = function (requestOptions) {
        var headers = requestOptions.headers = requestOptions.headers || {};
        if (state.token)
            headers[headerName] = state.token;

        requestOptions.recoverFromAntiforgeryRejection = function (replay, giveUp) {
            csrfToken.recover(headers[headerName], function () {
                headers[headerName] = state.token;
                replay();
            }, giveUp);
        };
        return requestOptions;
    };

    // Called when the logged in user is no longer the user the page was rendered for (e.g. someone else logged in, in
    // another tab of the same browser). Whatever is on screen was not meant for the new user, so the page does not get
    // a token that would let the new user submit it. The listener (the runtime's error handler, see RuntimePiping)
    // covers the page with a dialog that offers to reload it; it has to cope with being called more than once.
    csrfToken.onUserChanged = function (listener) {
        userChangedListener = listener;
    };

    csrfToken.reloadPage = function () {
        window.location.reload();
    };

    csrfToken.handleUserChanged = function () {
        if (userChangedListener)
            userChangedListener();
        else
            csrfToken.reloadPage();
    };

    return csrfToken;
});

